import _map from 'lodash/map';

import initialState from './initialState';
import actionTypes from './actionTypes';

const defaultConfigurationReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.GET_DEFAULT_MATCHING_RULE_SUCCESS:
            return {
                ...state,
                matchingTypes: action.payload,
                matchingTypesForSelectionBox: _map(action.payload, (item) => ({
                    ...item,
                    label: item.rule_name,
                    value: item.rule_name,
                })),
            };
        case actionTypes.GET_DEFAULT_MATCH_STATUS_SUCCESS:
            return {
                ...state,
                matchStatusTypes: action.payload,
                matchStatusTypesForSelectionBox: _map(action.payload, (item) => ({
                    ...item,
                    label: item.label,
                    value: item.value,
                })),
            };
        case actionTypes.GET_DEFAULT_FILTERS_SUCCESS:
            return {
                ...state,
                defaultFilters: action.payload,
                defaultFiltersForSelectionBox: _map(action.payload, (item) => ({
                    ...item,
                    label: item.label,
                    value: item.value,
                })),
            };
        case actionTypes.GET_DEFAULT_MATCHING_CONDITION_SUCCESS:
            return {
                ...state,
                defaultMatchingConditions: action.payload,
                defaultMatchingConditionsForSelectionBox: _map(action.payload, (item) => ({
                    ...item,
                    label: item.label,
                    value: item.value,
                })),
            };
        case actionTypes.GET_REF_DATA_MATCHING_CONDITION_SUCCESS:
            return {
                ...state,
                refDataMatchingConditions: action.payload,
                refDataMatchingConditionsForSelectionBox: _map(action.payload, (item) => ({
                    ...item,
                    label: item.label,
                    value: item.value,
                })),
            };
        case actionTypes.GET_DEFAULT_FIXED_CONDITION_SUCCESS:
            return {
                ...state,
                defaultFixedConditions: action.payload,
                defaultFixedConditionsForSelectionBox: _map(action.payload, (item) => ({
                    ...item,
                    label: item.label,
                    value: item.value,
                })),
            };
        case actionTypes.GET_REF_DATA_FIXED_CONDITION_SUCCESS:
            return {
                ...state,
                refDataFixedConditions: action.payload,
                refDataFixedConditionsForSelectionBox: _map(action.payload, (item) => ({
                    ...item,
                    label: item.label,
                    value: item.value,
                })),
            };
        default:
            return state;
    }
};

export default defaultConfigurationReducer;
